import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

function Row({ label, value }) {
  return (
    <div className="flex justify-between gap-6 text-sm">
      <span className="text-slate-400 font-mono text-xs uppercase tracking-[0.1em]">{label}</span>
      <span className="text-foreground text-right">{value}</span>
    </div>
  );
}

/** Confirmation screen shown after a booking is successfully submitted. */
export function BookingSuccess({ done }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 pt-40 pb-24 text-center">
        <CheckCircle2 className="h-14 w-14 mx-auto text-slate-900" strokeWidth={1.2} />
        <h1 className="font-display text-5xl md:text-6xl tracking-tight mt-6">{done.schedule_status === "pending_assignment" ? "Booking received" : "Booking confirmed"}</h1>
        <p className="text-slate-500 mt-3">Reference <span className="font-mono text-foreground">{done.reference}</span>. {done.schedule_status === "pending_assignment" ? "We’re assigning your photographer and will confirm shortly." : `A confirmation email is on its way to ${done.contact.email}.`}</p>
        <div className="border border-border mt-10 text-left p-8 space-y-3 bg-card">
          <Row label="Property" value={`${done.address.street}, ${done.address.city}`} />
          {done.scheduled_date && <Row label="Date & time" value={`${done.scheduled_date} at ${done.scheduled_time}`} />}
          <Row label="Services" value={done.quote.line_items.map((l) => l.name).join(", ")} />
          <Row label="Total" value={`$${done.quote.total}`} />
        </div>
        <div className="flex gap-4 justify-center mt-10">
          <Button data-testid="done-dashboard-btn" onClick={() => navigate("/dashboard")} className="rounded-none bg-slate-900 hover:bg-slate-800 text-slate-50 px-8">Go to dashboard</Button>
          <Button data-testid="done-home-btn" variant="ghost" onClick={() => navigate("/")} className="rounded-none px-8 border border-slate-300">Back home</Button>
        </div>
      </div>
    </div>
  );
}
